import { render, staticRenderFns } from "./OverviewReport.vue?vue&type=template&id=5767505a&"
import script from "./OverviewReport.vue?vue&type=script&lang=js&"
export * from "./OverviewReport.vue?vue&type=script&lang=js&"
import style0 from "./OverviewReport.vue?vue&type=style&index=0&id=5767505a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports